import React from "react";
import PlatformAnalyticsExperience from "./PlatformAnalyticsExperience";

/*
 * Facebook Analytics — served by the shared Platform Analytics experience. The
 * route, page title, report-link contract and topline data contract are
 * unchanged; the profile lives in
 * src/platformAnalytics/platformAnalyticsProfiles.js.
 *
 * This was a container change, not a reporting change. The live Meta ads
 * library moves with the page, and it is that component which owns the
 * publisher identity, the separately-governed Audience Network and Messenger
 * delivery, and the reconciliation that keeps those placements from inflating
 * Facebook totals. None of that is reimplemented here.
 *
 * No routed connector reports Meta creative-level delivery, so the profile
 * declares no creativePerformancePlatformKey and Creative Performance renders
 * its governed unsupported state.
 */
export default function FacebookAnalytics() {
  return <PlatformAnalyticsExperience platformKey="facebook" />;
}
